import { useTranslation } from '@thoughtspot/i18n';
import { Horizontal } from '@thoughtspot/radiant-react/widgets/layout';
import { LoadingIndicator } from '@thoughtspot/radiant-react/widgets/loading-indicator';
import { Select } from '@thoughtspot/radiant-react/widgets/select';
import { Table } from '@thoughtspot/radiant-react/widgets/table';
import { Typography, } from '@thoughtspot/radiant-react/widgets/typography/typography';
import React, { useEffect, useState } from 'react';
import { useGetAdminCombinedNodeInfo, useGetAdminCombinedTableInfo, } from "../../../../services/system/table-status-service/table-status-service";
import { Vertical } from "../../../../utils/layouts";
import styles from '../table-status-cards.module.scss';
import { nodeList, prepareTableRowDataEvents, TableInfoColumns, } from '../table-status-cards/table-status-utils';
export const TableInfoGridContainer = () => {
    const { getAdminCombinedTableInfo, data, loading, } = useGetAdminCombinedTableInfo();
    const { getAdminCombinedNodeInfo, data: nodeData, } = useGetAdminCombinedNodeInfo();
    const { t } = useTranslation();
    const [selectedTableInfo, setSelectedTableInfo] = useState('all');
    const [options, setOptions] = useState([]);
    const [node, setNode] = useState('all');
    const [tableData, setTableData] = useState([]);
    useEffect(() => {
        getAdminCombinedTableInfo(node);
        getAdminCombinedNodeInfo();
    }, []);
    useEffect(() => {
        if (nodeData) {
            setOptions(nodeList(nodeData.nodes));
        }
    }, [nodeData]);
    useEffect(() => {
        if (data && !loading) {
            setTableData(prepareTableRowDataEvents(data.tables));
        }
    }, [data, loading]);
    useEffect(() => {
        getAdminCombinedTableInfo(node);
    }, [node]);
    return (React.createElement(Vertical, { className: styles.tableComponent, "data-testid": "table-info-testId" },
        React.createElement(Horizontal, { className: styles.tableStatusMarginBottom },
            React.createElement(Typography, { variant: "h3" }, t('adminUI.messages.SEARCH_DETAIL_TABLE_TITLE'))),
        React.createElement(Horizontal, { className: styles.dropdownStyle },
            React.createElement(Vertical, null,
                React.createElement(Typography, { variant: "body-normal", className: styles.selectDropdownTitle }, t('adminUI.table.info.select.dropdown.placeholder'))),
            React.createElement(Vertical, { className: styles.selectDropdown },
                React.createElement(Select.Dropdown, { "data-testid": "node-dropdown-testid", id: "nodeDropdownId", optionsGroups: options, selectedOptions: [selectedTableInfo], onChange: (event) => {
                        setSelectedTableInfo(event.id);
                        setNode(event.id);
                    } }))),
        React.createElement(LoadingIndicator.Global, { className: styles.loader, hideLoader: !loading, "data-testid": "loader" }, tableData ? (React.createElement(Vertical, null,
            React.createElement(Horizontal, { className: styles.tableGridComponent },
                React.createElement(Table, { data: tableData, columns: TableInfoColumns })),
            React.createElement(Horizontal, { className: styles.tableRowCountMarginTop },
                React.createElement(Typography, { variant: "body-normal" }, t('pagination_footer', {
                    total: tableData.length,
                }))))) : null)));
};
//# sourceMappingURL=table-info-grid.container.js.map